import { Navigate } from "react-router-dom";
import { Spinner } from 'react-bootstrap'
import useSessionGate from '../hooks/useSessionGate'


function ProtectedRoute({ isMandatory, children }) {

    const { isChecking, isAuthenticated } = useSessionGate()

    if (isChecking) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" as={'span'} style={{width: '20px', height: '20px'}}/>
            </div>
        )
    }

    if (isMandatory) {
        return isAuthenticated ? children :
        <Navigate to={'/'} />;
    }
    else {
        return children
    }

}

export default ProtectedRoute;
